<template>
    <div class="dtx-bread-crumbs">
        <ul>
            <li v-for="(breadcrumb, index) in crumbs" :key="index">
                <router-link v-if="breadcrumb.link" :to="breadcrumb.link">{{ breadcrumb.label }}</router-link>
                <span v-else>{{ breadcrumb.label }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'dtxBreadCrumbs',
    props: {
        crumbs: {
            type: Array,
            default: () => [{
                label: 'Home',
                link: '/'
            }]
        }
    },
    computed: {},
    methods: {}
};
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';

.dtx-bread-crumbs {
    border-bottom: $primary-dark-border;
    padding: 1em 0;
    margin-bottom: 1.5em;
    ul {
        display: block;
        color: #fff;
        padding: 0;
        margin: 0;
        li {
            display: inline-block;
            font-size: 0.90rem;
            font-weight: 500;

            a {
                color: $accent;
            }

            &:after {
                content: "/";
                display: inline-block;
                padding: 0 4px 0 7px;
            }

            &:last-child {
                &:after {
                    display: none;
                }
            }
        }
    }
}
</style>